import React from "react";
import { View, ViewStyle } from "react-native";
import { SvgXml } from "react-native-svg";
import { resolveNativeIconSize } from "@xsolla/xui-primitives-core";
import type { BaseIconInternalProps } from "./types";

export const BaseIcon: React.FC<BaseIconInternalProps> = ({
  variant = "line",
  size = 24,
  color = "currentColor",
  solidContent,
  lineContent,
  style,
  testID,
  "aria-label": ariaLabel,
}) => {
  const svgContent = variant === "line" ? lineContent : solidContent;

  // Percentages resolve against the parent here just as they do on web; other
  // CSS lengths warn and fall back rather than silently rendering at 24.
  const resolvedSize = resolveNativeIconSize(size, 24);

  const containerStyle: ViewStyle = {
    width: resolvedSize,
    height: resolvedSize,
    alignItems: "center",
    justifyContent: "center",
    ...(style as ViewStyle),
  };

  // Replace currentColor with actual color for React Native
  const coloredSvg = svgContent.replace(/currentColor/g, color);

  return (
    <View
      style={containerStyle}
      testID={testID}
      accessible={!!ariaLabel}
      accessibilityLabel={ariaLabel}
      accessibilityRole={ariaLabel ? "image" : undefined}
    >
      <SvgXml xml={coloredSvg} width="100%" height="100%" />
    </View>
  );
};
